import request from "@/utils/request";

// 获取记录
export function getList(data) {
  return request.post("/oilInStock/getPage", data);
}
// 获取记录
export function getOilInStockPage(data) {
  return request.post("/oilInStock/oilInStockPage", data);
}
export function add(data) {
  return request.post("/oilInStock/addInStock", data);
}
export function update(data) {
  return request.post("/oilInStock/updateInStock", data);
}

// 删除
export function del(data) {
  return request.get("/oilInStock/deleteRecordById/" + data.id);
}
